<template>
    <div class="charts">
        <div class="charts__body chart">
            <!--<div class="chart__title" v-show="getTitle">Баланс</div>-->
            <transition
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut">
                <notif v-if="noti"></notif>
            </transition>
            <div class="chart__item chart__item--h70 echarts" v-if="show">
                <div class="chart__info">
                    <sum-data :symbol="symbol" :periodMenu="false">
                    </sum-data>
                </div>

				<chart-profit
					:update="update"
					:updateRight="updateRight"
					:updateHeight="updateHeight"
					:symbol="symbol">
				</chart-profit>

            </div>
            <div class="chart__item chart__item--h30 echarts">
                <chart-maxdd
                    :update="update"
                    :updateRight="updateRight"
                    :updateHeight="updateHeight"
                    :symbol="symbol">
                </chart-maxdd>
            </div>
        </div>
    </div>
</template>
<script>
import ChartProfitLastDays from './sig-last-days-chart';
import ChartMaxdd from './sig-maxdd-last-days';
import SummaryDate from '../profitability/sig-summary-account-data';
import Notifications from '../header/sig-notifications-on-chart'
export default {
	data() {
		return {
			show: true
		}
	},
    props: {
        update:{default:true},
        updateRight:{default:true},
        updateHeight:{default:true},
        symbol:{default:''},
        noti:{default:true}
    },
    components: {
        "chart-profit":ChartProfitLastDays,
        "chart-maxdd":ChartMaxdd,
        "sum-data":SummaryDate,
        "notif":Notifications
    },
    computed: {
        getTitle() {
            return (this.symbol == '') ? true : false;
        }
    }
}
</script>
<style lang="less" scoped>
.chart__item--h70 {
    background-image: linear-gradient(to top, rgba(54, 226, 255, 0.4), rgba(0, 175, 255, 0));
}

.chart__noti {
    position: absolute;
    top:170px;
    left: 8px;
    z-index: 3;
}

.chart__item--h30 {
    background-image: linear-gradient(to top, rgba(255, 146, 146, 0.1), rgba(255, 146, 146, 0.2));
}
</style>
